import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signout-message',
  templateUrl: './signout-message.component.html',
  styleUrls: ['./signout-message.component.sass'],
  standalone: false,
})
export class SignoutMessageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
